<template>
    <div class="login-container">
	    <div class="login-container-wrapper">
		    <div v-if="!isReset" class="form-login">
			    <div>
				    <v-text-field
						    v-model="email"
						    :error-messages="emailErrors"
						    label="E-mail"
						    required
						    @input="$v.email.$touch()"
						    @blur="$v.email.$touch()"
						    name="username"
						    autocomplete="username"
				    />
			    </div>
			    <div>
				    <v-text-field
						    :type="type"
						    v-model="password"
						    :error-messages="passwordErrors"
						    label="Password"
						    required
						    @input="$v.password.$touch()"
						    @blur="$v.password.$touch()"
						    :append-icon="marker ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
						    @click:append="toggleMarker"
						    name="password"
						    autocomplete="current-password"
				    />
			    </div>

			    <div class="btn-holder">
				    <v-btn class="btn-default mr-4" @click="clear">clear</v-btn>
				    <v-btn type="submit" class="btn-success" @click="submit">LogIn</v-btn>
			    </div>

			    <div>
				    <button @click="resetPass" type="button" class="green--text d-flex mt-3 mb-2 mr-auto ml-auto">
					    <svg-sprite width="20" height="20" icon-id="resetPassword"></svg-sprite>
					    <span class="ml-2">Forgot password?</span>
				    </button>
			    </div>

			    <div class="mt-4" v-if="isGeoErrorWrap && geoErrorId === 2">
				    <p><b>{{ geoErrorText }}</b></p>
				    <p>Enable geolocation to check in/out remotely.</p>
				    <p><small>❌ Unfortunately, the browser blocks automatic access to the required settings. 📋 Copy and paste this link into your browser:</small></p>
				    <v-row class="mt-2 mb-2" align="center" justify="space-around">
					    <v-btn type="button" color="warning" @click="copyToClipboard('location')">📋 Copy link to the location page</v-btn>
				    </v-row>
				    <p v-if="copied" style="color: green;">✅ Link copied! Paste it into your browser.</p>
				    <p v-if="copyError" style="color: red;">❌ Copying failed. Try again.</p>
			    </div>

			    <div class="mt-4" v-if="isGeoErrorWrap && geoErrorId === 8">
				    <p><b>{{ geoErrorText }}</b></p>
				    <p>Enable geolocation to check in/out remotely.</p>
				    <p><small>🔍 It has been noticed that using extensions like "Urban VPN Proxy" or similar ones that can modify location data may affect access. 🌍</small></p>
				    <p><small>⚙️ Go to your extensions settings and disable them. 🔌🚫</small></p>
				    <p><small>❌ Unfortunately, the browser blocks automatic access to the required settings. 📋 Copy and paste this link into your browser:</small></p>
				    <v-row class="mt-2 mb-2" align="center" justify="space-around">
					    <v-btn type="button" color="warning" @click="copyToClipboard('extensions')">📋 Copy link to the extensions page</v-btn>
				    </v-row>
				    <p v-if="copied" style="color: green;">✅ Link copied! Paste it into your browser.</p>
				    <p v-if="copyError" style="color: red;">❌ Copying failed. Try again.</p>
			    </div>

		    </div>
		    <Reset v-else @to-login="toLogin"/>
		    <preload v-if="preloader"></preload>
	    </div>
    </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
// import { mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import Preload from "@/shared/Preload/Preload";
const Reset = () => import('../refresh-pass/refresh-pass.component');

import {
	required,
	email,
	minLength,
} from "vuelidate/lib/validators";

import { getGeolocationStatus } from "@/helper/getGeolocationStatus";
import { DATE } from "@/constants/date";

// import { PERMISSIONS } from "@/constants/constants";
// import sha256 from "sha256";

export default {
	name: "Login",
	mixins: [ validationMixin ],
	validations: {
		email: { required, email },
		password: {
			required,
			minLength: minLength(6),
		},
	},
	components: {
		Preload,
		Reset
	},
	data: () => ({
		DATE,
		password: "",
		email: "",
		isReset: false,
		preloader: false,
		geolocationStatus: false,
		geolocationInfo: null,
		copied: false,
		copyError: false,
		isGeoErrorWrap: false,
		geoErrorText: null,
		geoErrorId: null,

		marker: true,
		type: 'password',
	}),

	computed: {
		...mapGetters([
			// 'permissions'
			'roleLogin',
			'customersLogin'
		]),
		// getPermissionAction() {
		// 	return this.permissions[PERMISSIONS.PROFILE];
		// },
		emailErrors() {
			const errors = [];
			if (!this.$v.email.$dirty) return errors;
			!this.$v.email.email && errors.push("Must be valid e-mail");
			!this.$v.email.required && errors.push("E-mail is required");
			return errors;
		},
		passwordErrors() {
			const errors = [];
			if (!this.$v.password.$error) return errors;
			!this.$v.password.minLength &&
            errors.push("Min lenghts password 6 chars");
			!this.$v.password.required && errors.push("Password is required");
			return errors;
		},
	},

	methods: {
		...mapActions([ 'login', 'setAlert' ]),
		toggleMarker() {
			if (this.marker) {
				this.marker = false;
				this.type = 'text';
			} else {
				this.marker = true;
				this.type = 'password';
			}
		},
		async submit() {
			this.preloader = true;

			// const status = true;
			// const id = 10;
			const { status, id, text } = await getGeolocationStatus();
			this.geoErrorId = id;
			console.info(id, status, text);

			if (!status && id === 2) {
				this.isGeoErrorWrap = true;
				this.geoErrorText = 'You have disabled location tracking. 📍❌';
				this.setAlert({ type: "error", message: '❌ Geolocation is disabled. To check in/out remotely, you need to enable geolocation access.' });
				this.preloader = false;
			} else if (!status && id === 8) {
				this.isGeoErrorWrap = true;
				this.geoErrorText = 'The service cannot access your location data. 📍🚫';
				this.setAlert({ type: "warning", message: '🚫 The service cannot access your location data. This might be blocked by one of your browser extensions, such as a VPN, an ad blocker, or something else. 🛑🔧' });

				this.preloader = false;
			} else if (status) {
				this.isGeoErrorWrap = false;
				this.preloader = false;

				if (!this.$v.email.$error && !this.$v.password.$error) {

					try {
					// sha256(this.password)
						const { role } = await this.login({ email: this.email, password: this.password });
						if (!role) return false;

						if (role.toLowerCase() === "fleet manager" || role.toLowerCase() === "shop employees" ) {
							await this.$router.replace({ path: "/fleet" });
						// } else if (role.toLowerCase() === "customer") {
						} else if (this.customersLogin) {
							await this.$router.replace({ path: "/" });
						} else {
							await this.$router.replace({ path: "/account" });
						// await this.$router.replace({ path: "/profile" });
						}
					} catch (e) {
						console.error(e);
					}
				}
			} else {
				this.preloader = false;
				this.isGeoErrorWrap = true;
				this.setAlert({ type: "warning", message: '🚫Geolocation is disabled. To check in/out remotely, you need to enable geolocation access.' });
			}

		},
		clear() {
			this.$v.$reset();
			this.email = "";
			this.password = "";
		},
		resetPass() {
			this.isReset = true;
		},
		toLogin() {
			this.isReset = false;
		},
		getExtensionsUrl() {
			let url = "🔎 Пожалуйста, откройте страницу расширений вручную.";

			if (navigator.userAgent.includes("Chrome")) {
				url = "chrome://extensions/";
			} else if (navigator.userAgent.includes("Edg")) {
				url = "edge://extensions/";
			} else if (navigator.userAgent.includes("Firefox")) {
				url = "about:addons";
			} else if (navigator.userAgent.includes("Opera") || navigator.userAgent.includes("OPR")) {
				url = "opera://extensions/";
			}

			return url;
		},
		getSettingsUrl() {
			let url = "🔎 Відкрийте налаштування приватності вручну.";
			if (navigator.userAgent.includes("Chrome")) {
				url = "chrome://settings/content/location";
			} else if (navigator.userAgent.includes("Edg")) {
				url = "edge://settings/content/location";
			} else if (navigator.userAgent.includes("Firefox")) {
				url = "about:preferences#privacy";
			} else if (navigator.userAgent.includes("Opera") || navigator.userAgent.includes("OPR")) {
				url = "opera://settings/content/location";
			}
			return url;
		},
		copyToClipboard(key) {
			const link = key === 'location' ? this.getSettingsUrl() : this.getExtensionsUrl();
			navigator.clipboard.writeText(link)
				.then(() => {
					this.copied = true;
					this.copyError = false;
				})
				.catch(err => {
					this.copyError = true;
					this.copied = false;
					console.error("❌ Copying failed. Try again:", err);
				});
		},
		// geo() {
		// 	navigator.geolocation.getCurrentPosition(
		// 		() => {
		// 		},
		// 		() => {
		// 		}
		// 	);
		// },

		/* Отримує геодані користувача та повертає Promise з результатом:
		 * true  - якщо користувач дозволив доступ до геоданих,
		 * false - якщо доступ заборонено або виникла інша помилка.
		 */
		// getLocation() {
		// 	return new Promise((resolve) => {
		// 		if (navigator.geolocation) {
		// 			navigator.geolocation.getCurrentPosition(
		// 				(position) => {
		// 					// Користувач дозволив доступ, зберігаємо позицію
		// 					this.position = position;
		// 					this.error = null;
		// 					console.log('Користувач дозволив доступ до геоданих.');
		// 					resolve(true);
		// 				},
		// 				(error) => {
		// 					// Обробка помилок
		// 					if (error.code === error.PERMISSION_DENIED) {
		// 						this.error = 'Користувач відмовився від доступу до геоданих.';
		// 					} else {
		// 						this.error = 'Помилка при отриманні геоданих: ' + error.message;
		// 					}
		// 					console.error(this.error);
		// 					resolve(false);
		// 				}
		// 			);
		// 		} else {
		// 			this.error = 'Ваш браузер не підтримує Geolocation API.';
		// 			console.error(this.error);
		// 			resolve(false);
		// 		}
		// 	});
		// },
		requestLocation() {
			this.preloader = true;
			navigator.geolocation.getCurrentPosition(
				() => {
					this.preloader = false;
					console.log('%c [  navigator.userAgent.includes  ] ', 'color:#bada55', typeof navigator.userAgent.includes, navigator.userAgent.includes );
					if (navigator.userAgent.includes("Firefox")) {
						if (!localStorage.getItem("geoFirefox")) {
							localStorage.setItem("geoFirefox", "1");
							// location.reload();
						}
					}
				},
				() => {
					this.preloader = false;
				}
			);
		},
	},
	async mounted() {
		console.log(navigator.platform);
		console.log(navigator.userAgent);
	}
};
</script>
<style lang="scss" scoped>
@import "login";
</style>
<style lang="scss" >
.login-container {
	.v-icon.v-icon {
		font-size: 18px !important;
	}
}
/* Лейбл наверху, если инпут автозаполнен браузером */
.login-container .v-text-field__slot:has(input:-webkit-autofill) .v-label {
	transform: translateY(-18px) scale(0.75);
	transform-origin: left top;
	/* можно ещё чуть уменьшить opacity, если надо */
}

/* На всякий случай — если вдруг у Vuetify другое смещение,
   можно чуть подправить значения translateY/scale под дизайн */
//.login-container .v-label {
//	transform: translateY(-18px) scale(0.75);
//	transform-origin: left top;
//}

.winter {
	.btnWr {
		position: relative;
		.icon {
			position: absolute;
			top: -8px;
			left: 30px;
		}
		.v-btn {
			width: 100%;
		}
	}
}
</style>
